export default __webpack_public_path__ + "static/media/paper2.732d25fd.svg";